import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router'
import { PagesContainer } from '../app/pages-container/pages-container'
import NotFoundPage from '../components/not-found-page/not-found-page'
import { USER_STORE } from '../store/stores'
import { getStore } from '../store/stores-repository'
import { LOGIN, MONITORING, NOT_FOUND, ROOT, VIOLATION_LOG } from './app-routes'
import { lazy } from '../utils/code-splitting'

// TODO На данный момент необходимо в react router 4 для вызова перерисовки при смене location
const Page = withRouter(PagesContainer)

export function renderAppRoutes() {
    const userStore = getStore(USER_STORE)

    const LoginPage = lazy(() => import(/* webpackChunkName: "login" */'../pages/login/login'))

    return (
        <Switch>
            <Route
                path={LOGIN}
                component={LoginPage}
            />

            { userStore.authorized &&
                <Route>
                    <Page>
                        {renderAppAuthorizedRoutes()}
                    </Page>
                </Route>
            }
        </Switch>
    )
}

export function renderAppAuthorizedRoutes() {
    const MonitoringPage = lazy(() => import(/* webpackChunkName: "monitoring" */'../pages/monitoring/monitoring'))
    const ViolationLogPage = lazy(
        () => import(/* webpackChunkName: "violation-log" */'../pages/violation-log/violation-log')
    )

    return (
        <Switch>
            <Redirect
                exact
                from={ROOT}
                to={MONITORING}
            />

            <Route
                path={MONITORING}
                component={MonitoringPage}
            />
            <Route
                path={VIOLATION_LOG}
                component={ViolationLogPage}
            />

            <Route
                path={NOT_FOUND}
                component={NotFoundPage}
            />

            <Redirect
                to={NOT_FOUND}
            />
        </Switch>
    )
}
